// extracted by mini-css-extract-plugin
module.exports = {"menu":"AddbuttonMenu_menu__tSZ69","menuButton":"AddbuttonMenu_menuButton__EnEXT","lastMenuButton":"AddbuttonMenu_lastMenuButton__3yIRf"};